var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "insta__ 1",
    clipPath: "url(#clip0_521_7818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_521_7818",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_467_6866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2727 0.726807H0V23.9995H23.2727V0.726807Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_521_7818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 0.726807H7.27273C5.34388 0.726807 3.49404 1.49304 2.13013 2.85694C0.766233 4.22084 0 6.07069 0 7.99953V16.7268C0 18.6557 0.766233 20.5055 2.13013 21.8694C3.49404 23.2333 5.34388 23.9995 7.27273 23.9995H16C17.9289 23.9995 19.7787 23.2333 21.1426 21.8694C22.5065 20.5055 23.2727 18.6557 23.2727 16.7268V7.99953C23.2727 6.07069 22.5065 4.22084 21.1426 2.85694C19.7787 1.49304 17.9289 0.726807 16 0.726807ZM21.0909 16.7268C21.0909 19.5341 18.8073 21.8177 16 21.8177H7.27273C4.46545 21.8177 2.18182 19.5341 2.18182 16.7268V7.99953C2.18182 5.19226 4.46545 2.90862 7.27273 2.90862H16C18.8073 2.90862 21.0909 5.19226 21.0909 7.99953V16.7268Z",
    fill: "#ADAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6365 6.54517C10.0935 6.54517 8.61356 7.15815 7.52243 8.24924C6.43134 9.34037 5.81836 10.8203 5.81836 12.3633C5.81836 13.9064 6.43134 15.3863 7.52243 16.4775C8.61356 17.5685 10.0935 18.1815 11.6365 18.1815C13.1796 18.1815 14.6595 17.5685 15.7507 16.4775C16.8417 15.3863 17.4547 13.9064 17.4547 12.3633C17.4547 10.8203 16.8417 9.34037 15.7507 8.24924C14.6595 7.15815 13.1796 6.54517 11.6365 6.54517ZM11.6365 15.9997C10.6725 15.9985 9.74825 15.6151 9.0665 14.9334C8.38483 14.2516 8.00134 13.3274 8.00018 12.3633C8.00018 10.3575 9.63218 8.72698 11.6365 8.72698C13.6409 8.72698 15.2729 10.3575 15.2729 12.3633C15.2729 14.3677 13.6409 15.9997 11.6365 15.9997Z",
    fill: "#ADAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8905 6.88526C18.3187 6.88526 18.6658 6.53816 18.6658 6.10999C18.6658 5.68182 18.3187 5.33472 17.8905 5.33472C17.4624 5.33472 17.1152 5.68182 17.1152 6.10999C17.1152 6.53816 17.4624 6.88526 17.8905 6.88526Z",
    fill: "#ADAFAF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_7818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2727,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.7e4edd73b001a78ec7c7bf3bde3b44bb.svg";
export { ForwardRef as ReactComponent };